/* Impression SCDM - minimum de commande.

   Empeche d aller a la caisse tant que le panier n atteint pas le minimum.
   Le montant se change dans snippets/scdm-minimum.liquid, PAS ici.

   Pourquoi bloquer au clic plutot que de simplement griser le bouton :
   le theme redessine le tiroir du panier a chaque ajout, donc un bouton
   grise redevient actif tout seul. Un ecouteur en phase de CAPTURE sur le
   document attrape le clic avant le theme, peu importe quand le bouton a
   ete cree.

   Les boutons de paiement rapide (Shop Pay, Apple Pay, Achat en 1 clic)
   sautent le panier au complet : sur une fiche dont le prix est deja sous
   le minimum, ils sont retires de la page, sinon le client contournerait
   la regle sans le savoir. */
(function () {
  'use strict';

  var MIN = Math.round(Number(window.SCDM_MIN || 40) * 100);   // en cents
  var total = null;                                            // null = pas encore lu

  var CAISSE = 'button[name="checkout"], input[name="checkout"], [data-testid="Checkout-button"], ' +
               'a[href="/checkout"], a[href^="/checkout?"], a[href$="/checkout"]';
  var RAPIDE = '.shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout, ' +
               'shopify-accelerated-checkout-cart, .additional-checkout-buttons, ' +
               '[data-shopify="dynamic-checkout-cart"], [data-shopify="payment-button"]';

  function argent(c) { return (c / 100).toFixed(2).replace('.', ',') + ' $'; }
  function manque() { return Math.max(0, MIN - (total || 0)); }
  function sousLeMinimum() { return total !== null && total > 0 && total < MIN; }

  function texte() {
    return 'Il manque ' + argent(manque()) + ' pour atteindre le minimum de commande de ' +
           argent(MIN) + '. Ajoutez d’autres articles pour continuer.';
  }

  /* ---------- Lecture du panier ---------- */

  var enLecture = null;
  function lirePanier() {
    if (enLecture) return enLecture;
    enLecture = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) total = c.total_price; })
      .catch(function () { /* hors ligne : on ne bloque pas */ })
      .then(function () { enLecture = null; appliquer(); });
    return enLecture;
  }

  /* Le theme ajoute au panier par fetch. On se branche dessus pour relire le
     total apres coup, sans dependre d un evenement propre au theme. */
  var fetchOrigine = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var chemin = (typeof url === 'string' ? url : (url && url.url) || '');
    var r = fetchOrigine.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(chemin)) {
      r.then(function () { setTimeout(lirePanier, 60); }, function () {});
    }
    return r;
  };

  /* ---------- Affichage ----------
     ATTENTION : appliquer() est rappele par le MutationObserver. Toute
     ecriture inutile dans le DOM le rappellerait en boucle. On n ecrit donc
     QUE si la valeur change. */

  function avis(pres) {
    var p = null, parent = pres.parentNode;
    if (!parent) return;
    var voisins = parent.querySelectorAll('.scdm-min-avis');
    if (voisins.length) p = voisins[0];
    if (!p) {
      p = document.createElement('p');
      p.className = 'scdm-min-avis';
      p.setAttribute('role', 'status');
      parent.insertBefore(p, pres);
    }
    var t = texte();
    if (p.textContent !== t) p.textContent = t;      // sinon : boucle infinie
  }

  function appliquer() {
    var bloque = sousLeMinimum();

    Array.prototype.forEach.call(document.querySelectorAll(CAISSE), function (b) {
      b.classList.toggle('scdm-bloque', bloque);
      if (bloque) {
        b.setAttribute('aria-disabled', 'true');
        avis(b);
      } else {
        b.removeAttribute('aria-disabled');
      }
    });

    if (!bloque) {
      Array.prototype.forEach.call(document.querySelectorAll('.scdm-min-avis'), function (p) {
        if (p.parentNode) p.parentNode.removeChild(p);
      });
    }

    /* Paiement rapide : il saute le panier. On le retire si le panier est sous
       le minimum, ou si le produit affiche ne peut pas l atteindre a lui seul. */
    var prix = window.SCDM_PRIX_PRODUIT;
    var cacher = bloque || (typeof prix === 'number' && prix > 0 && prix < MIN);
    Array.prototype.forEach.call(document.querySelectorAll(RAPIDE), function (el) {
      el.classList.toggle('scdm-cache', cacher);
    });
  }

  /* ---------- Blocage du clic ---------- */

  function alerter() {
    var p = document.querySelector('.scdm-min-avis');
    if (!p) return;
    p.classList.remove('secousse');
    void p.offsetWidth;                // force le navigateur a rejouer l animation
    p.classList.add('secousse');
    p.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    if (!sousLeMinimum()) return;
    var cible = (e.target && e.target.closest) ? e.target.closest(CAISSE + ',' + RAPIDE) : null;
    if (!cible) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    alerter();
  }, true);

  /* Le formulaire du panier peut aussi partir avec la touche Entree. */
  document.addEventListener('submit', function (e) {
    if (!sousLeMinimum()) return;
    var f = e.target;
    var action = (f && f.getAttribute && f.getAttribute('action')) || '';
    if (!/\/(cart|checkout)/.test(action)) return;
    var s = e.submitter;
    if (!s || s.name === 'checkout' || /checkout/i.test(action)) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      alerter();
    }
  }, true);

  /* ---------- Le panier se redessine : on repasse ---------- */

  var minuteur = null;
  new MutationObserver(function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(appliquer, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) lirePanier();
  });
  window.addEventListener('pageshow', lirePanier);

  lirePanier();
})();
